<template>
  <div
    class="
      z-50
      fixed
      inset-0
      bg-white
      flex flex-col
      justify-center
      items-center
    "
  >
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-28 text-cyan-600"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"
        />
      </svg>
    </div>
    <div>
      <h1 class="text-6xl font-bold text-gray-900">{{ networkIssue }}</h1>
    </div>
    <div class="mt-8 space-x-4">
      <button
        @click="goBackHome"
        type="button"
        class="
          px-4
          py-2
          border border-transparent
          rounded-md
          shadow-sm
          font-medium
          text-white
          bg-cyan-600
          hover:bg-cyan-700
          focus:outline-none
          focus:ring-2
          focus:ring-offset-2
          focus:ring-cyan-500
        "
      >
        กลับสู่หน้าหลัก
      </button>
      <button
        type="button"
        class="
          px-4
          py-2
          border border-transparent
          rounded-md
          shadow-sm
          font-medium
          text-cyan-700
          bg-cyan-100
          hover:bg-cyan-200
          focus:outline-none
          focus:ring-2
          focus:ring-offset-2
          focus:ring-cyan-500
        "
      >
        ติดต่อเจ้าหน้าที่
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetworkIssue',

  props: {
    networkIssue: {
      type: String,
      default: 'Network Error',
    },
  },

  methods: {
    goBackHome() {
      this.$router.push({ name: 'Dashboard' })
    },
  },
}
</script>
